export default {"src":"/_next/static/media/confusedMan.d80f9a89.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};